import { __awaiter } from "tslib";
import { ConsultationService } from "@/services/models/schedule/consultation";
const moduleConsultation = {
    namespaced: true,
    state: {
        consultation: [],
        nodeSelected: null,
        serviceNodeSelected: null,
        serviceNodeSelectedForTypeConsultation: null,
        locationSelected: null,
        loading: false,
    },
    getters: {
        getConsultation(state) {
            return state.consultation;
        },
        getLoading(state) {
            return state.loading;
        },
        getServiceNodeSelected(state) {
            return state.serviceNodeSelected;
        },
        getServiceNodeSelectedForTypeConsultation(state) {
            return state.serviceNodeSelectedForTypeConsultation;
        },
        getNodeSelected: (state) => state.nodeSelected,
        getLocationSelected: (state) => state.locationSelected,
    },
    mutations: {
        setConsultation(state, consultation) {
            state.consultation = consultation;
        },
        setNodeServiceNode(state, data) {
            (state.nodeSelected = data.node_id), (state.serviceNodeSelected = data.service_node || null), (state.locationSelected = data.location_id || null);
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setServiceNodeSelected(state, service_node) {
            state.serviceNodeSelected = service_node;
        },
        setServiceNodeSelectedForTypeConsultation(state, service_node) {
            state.serviceNodeSelectedForTypeConsultation = service_node;
        },
        setLocationSelected: (state, data) => (state.locationSelected = data),
        setNodeSelected: (state, data) => (state.nodeSelected = data),
        removeConsultation: (state, data) => (state.consultation = state.consultation.filter((item) => item.id != data)),
        addConsultation: (state, data) => (state.consultation = [...state.consultation, data]),
        editConsultation: (state, data) => (state.consultation = state.consultation.map((item) => (item.id == data.id ? Object.assign(Object.assign({}, item), data) : item))),
    },
    actions: {
        getConsultation({ commit }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const CONSULTATION = yield ConsultationService.getAll();
                commit("setConsultation", CONSULTATION);
                commit("setLoading", false);
            });
        },
        postConsultationServiceNode({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const CONSULTATION = yield ConsultationService.getByFilter(state.nodeSelected, state.serviceNodeSelected || null, state.locationSelected || null);
                commit("setConsultation", CONSULTATION);
                commit("setLoading", false);
            });
        },
        // getConsultationByNode
        // getConsultationByNodeAndServiceNode
        deleteConsultation({ commit }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const CONSULTATION_REMOVE = yield ConsultationService.remove(id);
                commit("setLoading", false);
                return CONSULTATION_REMOVE;
            });
        },
        createConsultation({ commit }, consultation) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const CONSULTATION_ADD = yield ConsultationService.create(consultation);
                commit("setLoading", false);
                return CONSULTATION_ADD;
            });
        },
        updateConsultation({ commit }, { id, data }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const CONSULTATION_EDIT = yield ConsultationService.update(id, data);
                commit("setLoading", false);
                return CONSULTATION_EDIT;
            });
        },
    },
};
export default moduleConsultation;
